import { InputText } from "primereact/inputtext";

import { FormField } from "@/ds";

import styles from "./campo-decimal.module.scss";
import type { CampoDecimalViewModel } from "./types-campo-decimal";

export function CampoDecimalView({
  label,
  labelOculto,
  prefixo,
  prefixoTestId,
  texto,
  inputRef,
  inputMode,
  error,
  placeholder,
  required,
  disabled,
  name,
  testId,
  digitar,
  sair,
}: CampoDecimalViewModel) {
  return (
    <FormField.Root required={required} error={error} disabled={disabled} name={name}>
      <FormField.Label visuallyHidden={labelOculto}>{label}</FormField.Label>
      {prefixo ? (
        <span className={styles.comPrefixo}>
          <span className={styles.prefixo} data-testid={prefixoTestId}>
            {prefixo}
          </span>
          <FormField.Control>
            <InputText
              ref={inputRef}
              className={styles.entradaComPrefixo}
              style={{ paddingInlineStart: `calc(${prefixo.length}ch + 1.5rem)` }}
              value={texto}
              placeholder={placeholder}
              inputMode={inputMode}
              autoComplete="off"
              data-testid={testId}
              onChange={(evento) => digitar(evento.target.value)}
              onBlur={sair}
            />
          </FormField.Control>
        </span>
      ) : (
        <FormField.Control>
          <InputText
            ref={inputRef}
            value={texto}
            placeholder={placeholder}
            inputMode={inputMode}
            autoComplete="off"
            data-testid={testId}
            onChange={(evento) => digitar(evento.target.value)}
            onBlur={sair}
          />
        </FormField.Control>
      )}
      <FormField.Error />
    </FormField.Root>
  );
}
